import { useQuery } from 'react-query'
import React, { Component } from "react";
import styled from "styled-components";
import { fetchUpgradesExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

async function fetch() {
    const { data } = await fetchUpgradesExplorer('byLabs')
    return data.result;
}
function UpgradesByLabs() {
    const { data, error, isError, isLoading } = useQuery('upgradesByLabs', fetch)
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer  {...dataProps } />
}
export default UpgradesByLabs